/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OpenGoal Platform API
 * Agency-facing API — day-to-day platform usage by agency users.
 * OpenAPI spec version: 1.0
 */

export type CreateSettlementDtoType = typeof CreateSettlementDtoType[keyof typeof CreateSettlementDtoType];


export const CreateSettlementDtoType = {
  owed_to_agency: 'owed_to_agency',
  owed_to_player: 'owed_to_player',
  deduction: 'deduction',
} as const;
